// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbs":"BreadCrumbs_breadCrumbs__ZmHX5","breadCrumb":"BreadCrumbs_breadCrumb__1xQjp","slash":"BreadCrumbs_slash__nEn3y"};